import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { environment } from '@env/environment';
import { isPublicApiUrl } from '@core/consts/public-access.const';
import { KeycloakSessionService } from '@core/services/auth/keycloak-session.service';
import { isAuthenticatedApi } from '@core/services/auth/api-target';
import { RUNTIME_CONFIG } from '@core/config/runtime-config';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  const session = inject(KeycloakSessionService);
  const config = inject(RUNTIME_CONFIG);
  if (
    !session.authenticated ||
    isPublicApiUrl(request.url) ||
    !isAuthenticatedApi(
      request.url,
      [
        environment.API_URL,
        environment.CHAT_API,
        environment.NOTIFICATION_API,
        environment.GIS_NAVIGATION_API,
        environment.PREDICTIVE_ANALYTICS_API_URL,
        config.auditApiUrl,
      ],
      location.origin,
    )
  ) {
    return next(request);
  }
  return from(session.accessToken()).pipe(
    switchMap((token) =>
      next(
        request.clone({ setHeaders: { Authorization: `Bearer ${token}` } }),
      ).pipe(
        catchError((error: unknown) => {
          if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
            return throwError(() => error);
          }
          return from(session.accessToken(token)).pipe(
            switchMap((refreshed) =>
              next(
                request.clone({
                  setHeaders: { Authorization: `Bearer ${refreshed}` },
                }),
              ),
            ),
          );
        }),
      ),
    ),
  );
};
